module.exports = __webpack_public_path__ + "img/4.91722303.png";